module.exports = __webpack_public_path__ + "img/paysec_QQPAY.f3108f47.svg";